import { Box, Skeleton } from "@mui/material";

const styles = () => {
  return {
    "& .summary": {
      display: "flex",
      alignItems: "center",
      py: 1,
      px: 2,
      mb: 1,
      borderBottom: "1px solid #ccc",
    },
  };
};

const SummaryLoader = () => {
  return (
    <Box sx={styles}>
      {[1, 2, 3, 4].map((i) => (
        <Box key={i} className="summary">
          <Skeleton
            height="80px"
            width="75px"
            variant="rectangular"
            animation="wave"
          />
          <Box
            className="flex items-center space-between"
            sx={{ flex: 1 }}
            ml={4}
          >
            <Box>
              <Skeleton
                width="80px"
                height="20px"
                variant="text"
                animation="wave"
                mb={1}
              />
              <Skeleton
                width="80px"
                height="20px"
                variant="text"
                animation="wave"
              />
            </Box>
            <Box>
              <Skeleton
                width="80px"
                height="20px"
                variant="text"
                animation="wave"
                mb={1}
              />
              <Skeleton
                width="80px"
                height="20px"
                variant="text"
                animation="wave"
              />
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default SummaryLoader;
